import React, { useCallback, useState } from "react";
import { FormControl, InputBase } from "@mui/material";
import { changeFilter } from "app/store/dashboard/doctor_analytic/slice/doctorAnalyticSlice";
import { useDispatch } from "react-redux";
import useDebounce from "app/hooks/useDebounce";

const NameFilter = () => {
  const [name, setName] = useState("");
  const dispatch = useDispatch();

  const debouncedDispatch = useCallback(
    useDebounce((name) => {
      dispatch(
        changeFilter({
          type: "name",
          value: name,
        })
      );
    }, 750),
    []
  );

  const handleInputChange = (event, callback) => {
    const value = event.target.value;
    callback(value);
    debouncedDispatch(value);
  };

  return (
    <FormControl fullWidth>
      <InputBase
        sx={{
          outline: "0px none !important",
          border: "1px solid #c4c4c4",
          padding: "0.7rem 1rem",
        }}
        onChange={(e) => handleInputChange(e, setName)}
        placeholder="Search by Name"
        value={name}
      />
    </FormControl>
  );
};

export default NameFilter;
